import { useState, useEffect } from 'react';
import * as S from './styles';
import { ButtonCarousel } from '../ButtonCarousel';
import { useNavigate } from 'react-router-dom';
import { linkImage } from 'utils/formatterArray';
import { useDateDifference } from 'hooks/useDateDifference';
import { useScreenWidth } from 'utils/useScreenWidth';

interface ICardResult {
  images: any[];
  width?: string;
}

type Result = {
  nameAd: string;
  region: string;
  city: string;
  bedrooms: number;
  meters: number;
  price: number;
  gadget?: string | boolean;
  maxGuests: number;
  acceptsPets: boolean;
  id: string;
  mainImage?: string;
  iptu?: number;
  condominium?: number;
  sumMonth: string | number;
  midStay: string | null | number;
  building_yogha: string;
};

export type CardResultProps = Result & ICardResult;

export const CardResult: React.FC<CardResultProps & { date: any, guest: any }> = ({ date, guest, ...card }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHover, setIsHover] = useState(false);
  const [mouseButton, setMouseButton] = useState(false);

  const breakpoint = useScreenWidth();

  const { dayDifference } = useDateDifference(date);

  const navigate = useNavigate();

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + card.images.length) % card.images.length);
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % card.images.length);
  };

  const getImage = () => {
    if (card.mainImage !== undefined) {
      if (card.images.length > 1) {
        return linkImage + card.images[currentIndex].image_path;
      } else {
        return `https://yogha-development.s3.amazonaws.com/${card.mainImage}`;
      }
    }
  };

  useEffect(() => {
    if (breakpoint) {
      setIsHover(true)
    }
  }, [breakpoint])



  const handleOpenProperty = () => {
    if (mouseButton) {
      return;
    } else {
      const url = `/property/${card.id}/${card.building_yogha}`;
      window.open(url, '_blank');
    }
  };

  // const handleButtonOnDisplayMobile = () => {
  //   if(breakpoint) {
  //       } else {

  //   }
  // }

  return (
    <>
      <S.ScaleContainer
        width={card.width}
        onClick={handleOpenProperty}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <S.SearchContainer>
          {card.gadget && (
            <S.Gadget>
              <p>{card.gadget}</p>
            </S.Gadget>
          )}
          {
            //<S.Favorites>
            //<ButtonFav />
            //</S.Favorites>
          }

          <S.ScaleImage src={getImage()} />
          <S.CollumnInfo>
            <S.Infos>
              <S.TextTitle>{card.nameAd}</S.TextTitle>
              <S.AddressText>
                {card.region} - {card.city}{' '}
              </S.AddressText>
            </S.Infos>
            {dayDifference < 27 ? (
              <S.Infos>
                <S.RowComplementDefault>
                  <S.TextComplement>{card.bedrooms} quarto(s)</S.TextComplement>
                  <S.TextComplement>
                    {' '}
                    {card.meters}m<sub>2</sub>
                  </S.TextComplement>
                  <S.TextComplement>{card.maxGuests} pessoa(s)</S.TextComplement>
                  <S.TextComplement> Não aceita pets</S.TextComplement>
                </S.RowComplementDefault>
                <S.TextOthers>
                  A partir de <S.TextPrice>{`R$ ${card.price && card.price.toFixed(0)},00 `}</S.TextPrice>
                  {'noite'}
                </S.TextOthers>
              </S.Infos>
            ) : (
              <S.Infos>
                <S.TextOthers>
                  <S.TextPrice>
                    {card.midStay !== null
                      ? parseFloat(card.midStay as string).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                      : parseFloat(card.sumMonth as string).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })}
                  </S.TextPrice>
                  Mês
                </S.TextOthers>
                <S.BuildingCounts>
                  <li>
                    Condomínio R${' '}
                    {card.condominium !== undefined
                      ? Math.round(card.condominium).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                      : 'R$ 0'}
                  </li>
                  <li>
                    IPTU{' '}
                    {card.iptu !== undefined
                      ? Math.round(card.iptu).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                      : 'R$ 0'}
                  </li>
                </S.BuildingCounts>
              </S.Infos>
            )}
          </S.CollumnInfo>

          <S.ButtonContainer hover={isHover}>
            <ButtonCarousel
              onMouseLeave={() => setMouseButton(false)}
              onMouseDown={() => setMouseButton(true)}
              size={40}
              iconSize={22}
              onClick={handlePrevClick}
              direction="left"
            />
            <ButtonCarousel
              onMouseLeave={() => setMouseButton(false)}
              onMouseDown={() => setMouseButton(true)}
              size={40}
              iconSize={22}
              onClick={handleNextClick}
              direction="right"
            />
          </S.ButtonContainer>
        </S.SearchContainer>
        <S.BulletContainer>
          {card.images.map((_: any, i: number) => {
            return <S.Bullet key={i} onClick={() => setCurrentIndex(i)} active={currentIndex === i ? true : false} />;
          })}
        </S.BulletContainer>
      </S.ScaleContainer>
    </>
  );
};
